<template>
    <div class="container-fluid">
        <Topbar />
        <div class="card shadow mx-3 conteudo text-left" style="margin-top: 90px">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary-dark">
                    <i :class="`${title.icon} mr-2`"></i>{{ title.text }}
                    <div v-show="carregando" class="spinner-grow">
                        <span class="sr-only">Loading...</span>
                    </div>
                </h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <fieldset v-if="isDataLoaded()" :disabled="carregando">
                            <Quadro :type="messageType" :message="message" />
                            <form>
                                <div class="d-print-none">
                                    <router-link
                                        :to="`/${this.baseUrl}`"
                                        id="btn_voltar"
                                        class="btn btn-secondary mr-1"
                                    >
                                        <i class="fa fa-arrow-left"></i> Voltar</router-link
                                    >
                                    <button type="button" id="btnSave" class="btn btn-primary mr-1" @click="salvar">
                                        Salvar
                                    </button>
                                    <button v-if="operation == 'update'" type="button" id="btnDuplicate" class="btn btn-primary mr-1" @click="duplicar">
                                        <i class="fas fa-copy"></i> Duplicar
                                    </button>
                                    <button
                                        type="button"
                                        id="btn_del"
                                        class="btn btn-danger mr-1"
                                        :disabled="operation === 'insert'"
                                        data-toggle="modal"
                                        data-target="#modalExcluir"
                                    >
                                        Excluir
                                    </button>
                                    <hr />
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <fieldset>
                                            <div class="form-row">
                                                <InputAndLabel
                                                    column="1"
                                                    name="id"
                                                    label="ID"
                                                    type="text"
                                                    v-model="dados[idname].value"
                                                    readonly
                                                />
                                                <InputAndLabel
                                                    column="7"
                                                    name="nome"
                                                    label="Nome"
                                                    type="text"
                                                    v-model="dados.nome.value"
                                                    :errorMessage="errors.nome"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="vigencia_ini"
                                                    label="Vigência Início"
                                                    type="date"
                                                    v-model="dados.vigencia_ini.value"
                                                    :errorMessage="errors.vigencia_ini"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="vigencia_fim"
                                                    label="Vigência Fim"
                                                    type="date"
                                                    v-model="dados.vigencia_fim.value"
                                                    :errorMessage="errors.vigencia_fim"
                                                />
                                            </div>
                                            <hr />
                                        </fieldset>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="card shadow" v-if="operation == 'update'">
                                            <div class="card-header bg-secondary py-3">
                                                <h6 class="m-0 font-weight-bold text-white row">
                                                    <div class="align-self-center">
                                                        <i class="fas fa-ruler-horizontal"></i> Faixas
                                                    </div>
                                                    <div v-show="carregando" class="spinner-grow">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </h6>
                                            </div>

                                            <div class="p-0 card-body">
                                                <div class="col-lg-12 table-responsive">
                                                    <table class="table table-sm table-striped table-bordered my-3">
                                                        <thead>
                                                            <tr style="white-space: nowrap">
                                                                <th>
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-primary"
                                                                        @click="() => abrirModalFaixa('insert')"
                                                                    >
                                                                        Lançar
                                                                    </button>
                                                                </th>
                                                                <th class="text-right">Percentual</th>
                                                                <th>Ticket Médio</th>
                                                                <th>Faturamento</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="line in dados.faixas"
                                                                :key="'faixa-' + line.idtabcob_faixas"
                                                            >
                                                                <td>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Editar/Visualizar"
                                                                        class="text-primary"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalFaixa(
                                                                                    line.idtabcob_faixas
                                                                                )
                                                                        "
                                                                    >
                                                                        <i class="fa fa-edit"></i>
                                                                    </a>
                                                                    <a
                                                                        data-toggle="tooltip"
                                                                        title="Excluir"
                                                                        class="text-danger"
                                                                        @click="
                                                                            () =>
                                                                                abrirModalDeleteFaixa(
                                                                                    line.idtabcob_faixas
                                                                                )
                                                                        "
                                                                    >
                                                                        <i class="fas fa-trash-alt"></i>
                                                                    </a>
                                                                </td>
                                                                <td class="text-right">{{ line.perc + "%" }}</td>
                                                                <td>{{ (line.faixa_ini_tm !== null ? decimalFormat(line.faixa_ini_tm) : '') + ' - ' + (line.faixa_fim_tm !== null ? decimalFormat(line.faixa_fim_tm) : '') }}</td>
                                                                <td>{{ (line.faixa_ini_fat !== null ? decimalFormat(line.faixa_ini_fat) : '') + ' - ' + (line.faixa_fim_fat !== null ? decimalFormat(line.faixa_fim_fat) : '') }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            v-if="operation == 'update'"
            id="modalFaixa"
            title="Faixa"
            confirmClass="btn btn-danger d-none"
            :confirmFunction="() => null"
            noFooter
        >
            <TabCobFaixa v-if="isDataLoaded()" :id="faixaSelecionada" :idparent="dados[idname].value" :parentBaseUrl="baseUrl" :parentGetData="getData" :parentSetFaixaSelecionada="setFaixaSelecionada"/>
        </Modal>
        <Modal
            id="modalExcluir"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deletar"
        >
            Tem certeza que deseja excluir esta tabela de cobrança?
        </Modal>
        <Modal
            id="modalDeleteFaixa"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deleteFaixa"
        >
            Tem certeza que deseja excluir esta faixa?
        </Modal>
        <ForbiddenModal />
        <LogoutModal />
        <Sidebar/>
    </div>
</template>

<script>
import api from "../services/api";
import Topbar from "@/components/Topbar";
import Sidebar from '@/components/Sidebar.vue';
import InputAndLabel from "@/components/InputAndLabel";
import Quadro from "@/components/Quadro";
import LogoutModal from "@/components/LogoutModal.vue";
import Modal from "@/components/Modal";
import TabCobFaixa from "@/views/TabCobFaixa";
import ViewMixin from "./ViewMixin";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import ForbiddenModal from "../components/ForbiddenModal.vue";

export default {
    name: "TabelaDeCobranca",
    mixins: [ViewMixin],
    components: {
        Topbar,
        Sidebar,
        LogoutModal,
        Modal,
        InputAndLabel,
        Quadro,
        ForbiddenModal,
        TabCobFaixa,
    },
    props: ["id"],
    data: function () {
        return {
            idname: "idtabcob",
            baseUrl: "tabcob",
            title: {
                icon: "fas fa-cash-register",
                text: "Tabela de Cobrança",
            },
            combos: {
                idcliente: [],
            },
            faixaSelecionada: "insert",
            // dados: {
            //   documento: ''
            // },
            mensagem: "",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.areYouSure(next);
    },
    mounted() {
        this.defineOperation(this.id);
        this.getCombo().then(this.getData);
    },
    methods: {
        async getCombo() {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.baseUrl}/combosToSave`);
                let data = response.data;
                this.combos = data;
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async getData(id = this.id) {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.baseUrl}/${id}`);
                let data = response.data;
                this.setData(data, ["faixas"]);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async salvar() {
            this.carregando = true;

            try {
                let response;
                let id = this.dados[this.idname].value;
                let newData;
                let fieldsToDelete = ["faixas"];
                if (this.operation === "update") {
                    newData = this.getDataToUpdate(fieldsToDelete);
                    response = await api.put(`/${this.baseUrl}/${id}`, newData);
                } else {
                    newData = this.getDataToInsert(fieldsToDelete);
                    response = await api.post(`/${this.baseUrl}`, newData);
                }
                let data = response.data;
                id = data.id;
                this.dados[this.idname] = { value: id, oldValue: id };
                this.operation = "update";

                this.updateData(newData);

                this.changeURL(`/${this.baseUrl}/${id}`);

                this.setMessage(data.successMessage, "success");
                this.errors = {};
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async duplicar() {
            this.carregando = true;

            try {
                let response;
                let id = this.dados[this.idname].value;
                response = await api.post(`/${this.baseUrl}/${id}/duplicate`);
                let data = response.data;
                id = data.id;

                this.changeURL(`/${this.baseUrl}/${id}`, true);
                this.id = id;
                await this.getData(id);

                this.setMessage(data.successMessage, "success");
                this.errors = {};
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
                console.error(e);
            }

            this.carregando = false;
        },
        async deletar() {
            this.carregando = true;

            $("#modalExcluir").modal("hide");

            try {
                let id = this.dados[this.idname].value;
                await api.delete(`/${this.baseUrl}/${id}`);

                this.$router.push(`/${this.baseUrl}`);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        setFaixaSelecionada(v) {
            this.faixaSelecionada = v;
        },

        abrirModalFaixa(id) {
            this.faixaSelecionada = id;
            $("#modalFaixa").modal("show");
        },

        abrirModalDeleteFaixa(id) {
            this.faixaSelecionada = id;
            $("#modalDeleteFaixa").modal("show");
        },

        async deleteFaixa() {
            this.carregando = true;

            $("#modalDeleteFaixa").modal("hide");

            try {
                let id = this.faixaSelecionada;
                await api.delete(`/${this.baseUrl}/${this.dados[this.idname].value}/faixas/${id}`);
                this.dados.faixas = this.dados.faixas.filter((el) => el.idtabcob_faixas != id);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
    },

    watch: {
        "dados.documento.value": {
            handler: function (newVal, oldVal) {
                console.log(newVal);
                console.log(oldVal);
            },
        },
    },
};
</script>

<style>
/* css */
</style>
